import React from 'react';
import usePageContext from '@hooks/usePageContext';
import { ArrowLink } from '@input';
import styles from './Pagination.module.scss';
import classNames from 'classnames';

export default function Pagination({
  className,
  prevText = 'Previous',
  nextText = 'Next'
}) {
  const { currentPage, numPages, slug } = usePageContext();

  if (!numPages || numPages === 1) {
    return null;
  }

  const isFirst = currentPage === 1;
  const isLast = currentPage === numPages;
  const prevPage =
    currentPage - 1 === 1 ? `/${slug}` : `/${slug}/${currentPage - 1}`;
  const nextPage = `/${slug}/${currentPage + 1}`;

  return (
    <div className={classNames(styles.wrapper, className)}>
      {!isFirst && (
        <ArrowLink
          to={prevPage}
          className={styles.prev}
          direction="left"
          rel="prev"
        >
          {prevText}
        </ArrowLink>
      )}
      {!isLast && (
        <ArrowLink
          to={nextPage}
          className={styles.next}
          rel="next"
        >
          {nextText}
        </ArrowLink>
      )}
    </div>
  );
}
